// src/admin/pages/Login.tsx
import React, { useState, useEffect, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import { handleLogin } from "../../shared/controllers/authController";

import authbg from "./assets/authbg.svg";
import load from "./assets/load.gif";
import logo from "./assets/logo.svg";

const AdminLogin: React.FC = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Get the item from localStorage
        const storedItem = localStorage.getItem("saca_admin_token");
        if (storedItem) {
            navigate("/admin");
        }
    }, [navigate]);

    // For handleLogin
    const onSuccess = (response: unknown) => {
        setLoading(false);
        try {
            const responseRecord =
                response && typeof response === "object"
                    ? (response as Record<string, unknown>)
                    : {};
            const data =
                responseRecord.data && typeof responseRecord.data === "object"
                    ? (responseRecord.data as Record<string, unknown>)
                    : {};

            const role = typeof data.role === "string" ? data.role : null;
            if (role) {
                localStorage.setItem("saca_admin_role", role);
            }
            const abilities = data.abilities;
            if (abilities) {
                localStorage.setItem("saca_admin_abilities", JSON.stringify(abilities));
            }
        } catch (e) {
            console.error("Error saving user permissions", e);
        }
        navigate("/admin");
    };

    const onError = () => {
        setLoading(false);
    };

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        setLoading(true);
        const userData = { email, password };
        handleLogin(userData, "admin", onSuccess, onError);
    };

    return (
        <div
            style={{
                backgroundImage: `url(${authbg})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
            }}
            className="w-full md:w-[120%] h-full bg-[#1212128d] z-[999] fixed top-0 left-0 md:-left-[20%] p-6 flex justify-center items-center"
        >
            <div className="md:ml-[20%] h-[550px] bg-[#FFFFFF] p-6 rounded-[15px] w-full md:w-[550px]">
                <div className="w-full h-full bg-[#fff] overflow-y-auto p-4 md:p-4 flex flex-col items-center">
                    <img src={logo} className=" w-[20%]" alt="SACA Logo" />
                    <p className=" mt-6 text-center font-Manrope font-bold text-[#272D37] text-3xl">
                        Welcome back!
                    </p>

                    <form className=" w-full mt-4" onSubmit={handleSubmit}>
                        <label
                            htmlFor="email"
                            className=" flex flex-col w-full font-Manrope font-semibold text-sm text-[#272D37]"
                        >
                            Email
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className=" mt-2 border border-[#DAE0E6] px-4 py-3 rounded-md font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                                placeholder="Enter your Email"
                                required
                            />
                        </label>
                        <label
                            htmlFor="password"
                            className=" flex flex-col mt-4 w-full font-Manrope font-semibold text-sm text-[#272D37]"
                        >
                            Password
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className=" mt-2 border border-[#DAE0E6] px-4 py-3 rounded-md font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                                placeholder="Enter your Password"
                                required
                            />
                        </label>

                        <button
                            type="submit"
                            disabled={loading}
                            className=" w-full py-3 bg-[#317333] mt-6 text-white font-Manrope font-semibold text-[15px] rounded-md flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed"
                        >
                            {loading ? (
                                <img src={load} className=" w-6" alt="Loading..." />
                            ) : (
                                "Log in"
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
